/*
 * @Author: Teemo Ding
 * @Date: 2021-10-14 14:41:07
 * @LastEditTime: 2021-10-15 14:59:11
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelSelection/config.tsx
 */
import moment from 'moment';
import React from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { formatDate1, generalSort } from 'src/tools/helper';
import css from './css.module.less';

export const columns = (timezoneInGmt, { getI18n }) => [
  {
    title: getI18n('legalPage.index.legalPageName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    optional: false,
    className: css.columnClass,
    width: 200,
    sorter: (a, b) => {
      const name1 = a.name || '';
      const name2 = b.name || '';
      return generalSort(name1, name2);
    },
  },
  {
    title: getI18n('legalPage.index.versionRemarks'),
    // dataIndex: 'channelType',
    default: true,
    optional: true,
    key: 'remarks',
    className: css.columnClass,
    childGenerate: (text, record, index) => {
      const { remarks } = record;
      return (
        <NoWrapContainer>
          <Tooltip title={remarks}>{remarks || '-'}</Tooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 180,
  },
  {
    title: `${getI18n('general.created')} (GMT ${timezoneInGmt})`,
    // dataIndex: 'channelType',
    default: true,
    optional: true,
    key: 'created',
    className: css.columnClass,
    sorter: (a, b) => {
      return moment(a.createdDate || null).isBefore(
        moment(b.createdDate || null),
      )
        ? -1
        : 1;
    },
    childGenerate: (text, record, index) => {
      const { createdDate } = record;
      const date = formatDate1(createdDate) || '-';
      return (
        <NoWrapContainer>
          <Tooltip title={date}>{date}</Tooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 180,
  },
  {
    sorter: (a, b) => {
      return moment(a.modifiedDate || null).isBefore(
        moment(b.modifiedDate || null),
      )
        ? -1
        : 1;
    },
    title: `${getI18n('general.lastModified')} (GMT ${timezoneInGmt})`,
    //dataIndex: 'channelType',
    default: true,
    optional: true,
    key: 'modified',
    className: css.columnClass,
    childGenerate: (text, record, index) => {
      const { modifiedDate } = record;
      const date = formatDate1(modifiedDate) || '-';
      return (
        <NoWrapContainer>
          <Tooltip title={date}>{date}</Tooltip>
        </NoWrapContainer>
      );
    },
    minWidth: 180,
  },
];
